import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { loadOllieFindings, removeFinding } from 'src/features/OllieSlice'
import {
  OLLIE_FINDINGS_SAVED_EVENT,
  ollieCheckIdsRefreshedByEvent,
} from 'src/utils/ollieFindingsRefresh'

/**
 * After a save on a page Ollie checks (Food Safety, Goods receipting,
 * invoices, credits, stock takes), drop the checks that write can clear
 * (same set everywhere — Part D), then re-read findings quietly for the
 * venue in view. Mount once per venue screen.
 */
const useOllieFindingsSaveListener = ({ venueId, enabled = true } = {}) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (!enabled || !venueId || typeof window === 'undefined') return undefined
    const onSaved = event => {
      const savedFor = event?.detail?.venueId
      if (savedFor && savedFor !== String(venueId)) return
      for (const checkId of ollieCheckIdsRefreshedByEvent(
        event?.detail?.event,
      )) {
        dispatch(removeFinding({ checkId }))
      }
      dispatch(
        loadOllieFindings({
          venueId,
          force: true,
          quiet: true,
          now: Date.now(),
        }),
      )
    }
    window.addEventListener(OLLIE_FINDINGS_SAVED_EVENT, onSaved)
    return () => window.removeEventListener(OLLIE_FINDINGS_SAVED_EVENT, onSaved)
  }, [dispatch, enabled, venueId])
}

export default useOllieFindingsSaveListener
